import React from "react";
import { useJumboApp } from "@jumbo/hooks";
import { LAYOUT_NAMES } from "../../../../layouts/layouts";
import LocalAsignarUsuario from "./LocalAsignarUsuario/LocalAsignarUsuario";

const AsignarLocalUsuario = () => {
  const { setActiveLayout } = useJumboApp();

  React.useEffect(() => {
    setActiveLayout(LAYOUT_NAMES.VERTICAL_DEFAULT);
  }, []);
  return (
    <div>
      <h2>Asignar Local Promotor </h2>
      <LocalAsignarUsuario />
    </div>
  );
};

export default AsignarLocalUsuario;
